import "./cafm.messages.jsx";
import "./cafm.autocomplete.jsx";
import "./cafm.lookup.jsx";
import "./cafm.grids.jsx";
import "./cafm.filters.jsx";
import "./cafm.listview.jsx";
import "./cafm.tab.jsx";
import "./cafm.panelbar.jsx";
import "./cafm.treeview.jsx";
import "./cafm.scheduler.jsx";
import "./cafm.toolbar.jsx";
import "./cafm.loadingpanel.jsx";
import "./cafm.fileupload.jsx";
import "./cafm.scanner.jsx";
import { Grid, GridColumn } from "@progress/kendo-grid-react-wrapper";
import { ButtonGroup, Button } from "@progress/kendo-react-buttons";
import { Menu, MenuItem} from "@progress/kendo-layout-react-wrapper";

export class HistoryList extends React.Component {

    componentDidMount() {
        this.setup();
    }

    setup() {
        window.HistoryList = this;
        $("<span class=\"caret-down\"></span>").appendTo($(".history-menu-item .k-link").attr("title", this.props.options.title));
        cafm.util.callFunctionAsync({
            func: function () {
                $(".history-menu-item").kendoTooltip({
                    showOn: "click",
                    autoHide: false,
                    animation: false,
                    content: function (e) {
                        return $(".history").show();
                    },
                    show: function (args) {
                        cafm.filters.hideFilterPanel();
                        $(".history").show().closest(".k-animation-container").addClass("header-right-tooltip-container");
                        args.sender.popup.element.addClass("header-widget-tooltip");
                    }
                });
            }, timeout: 100
        });
    }

    refresh() {
        let ttip = $(".history-menu-item").getKendoTooltip();
        if (ttip) ttip.hide();
        $('#' + this.props.options.ClientId).refreshListDS();
    }

    dataBound(args) {

        args.sender.element.kendoTooltip({
            filter: "button[data-key=Info]",
            position: "left",
            content: function (e) {
                let item = args.sender.dataItem($(e.target).closest(".k-item"));
                console.log(item == null);
                var result = ["<div class=\"history-info\" open>"];
                result.push("<header>Viewed: {0}</header>".format(item.itemViewed));
                if (item.itemDetail) {
                    result.push("<p>{0}</p>".format(cafm.util.toSafeHtml(cafm.util.reduceString(item.itemDetail, 150, "..."), null, true)));
                }
                result.push("</div>");
                return result.join("");
            },
            show: function (args) {
                args.sender.popup.element.addClass("header-widget-tooltip");
            }
        })
    }

    render() {
        this.props.options.OnDataBound = this.dataBound;
        return (
            <div className="history popup-list-wrapper">
                <h2>{this.props.options.title}</h2>
                <script type="text/x-kendo-template" id={this.props.options.ClientId + "-item-template"}>
                    <li className="k-item" data-key="#:itemKey#">
                        <a className="k-link" href="#:navUrl#">
                            <span className="k-sprite #:data.itemType ? cafm.enums.getEnumKey(cafm.enums.HistoryItemType, itemType).toLowerCase() : ''#"></span>
                            #:data.itemTitle#
                        </a>
                        <div className="k-button-group">
                            <Button icon="info" look="bare" data-key="Info"></Button>
                        </div>
                    </li>
                </script>
                <CafmListView options={this.props.options} />
            </div>
        );
    }
}

export class SavedSearchList extends React.Component {

    componentDidMount() {
        this.setup();
    }

    setup() {
        window.SavedSearchList = this;
        $("<span class=\"caret-down\"></span>").appendTo($(".saved-search-menu-item .k-link").attr("title", this.props.options.title));
        cafm.util.callFunctionAsync({
            func: function () {
                $(".saved-search-menu-item").kendoTooltip({
                    showOn: "click",
                    autoHide: false,
                    content: function (e) {
                        return $(".saved-searches").show();
                    },
                    show: function (args) {
                        cafm.filters.hideFilterPanel();
                        $(".saved-searches").show().closest(".k-animation-container").addClass("header-right-tooltip-container");
                        args.sender.popup.element.addClass("header-widget-tooltip");
                    }
                });
            }, timeout: 100
        });
    }

    refresh() {

        $(".saved-search-menu-item").getKendoTooltip().hide();
        $('#' + this.props.options.ClientId).refreshListDS();
    }

    dataBound(args) {
        
        args.sender.element.off("click.cafm").on("click.cafm", "[data-key=Edit],[data-key=Delete]", function (e) {

            let btn = $(e.currentTarget);
            let item = btn.closest(".k-item");
            let hash = "#savedSearch/{0}".format(item.data("subkey"));

            switch (btn.data("key")) {

                case "Edit":
                    window.SavedSearchList.edit(item, hash);
                    break;
                case "Delete":
                    window.SavedSearchList.delete(item, hash);
                    break;
            }
        });
    }

    edit(item, hash) {

        if (window.location.hash != hash) {
            cafm.filters.openOnNextLoad = true;
            cafm.url.hash(hash);
        }
        else {
            cafm.filters.showPanel();
        }
    }

    delete(item, hash) {
        
        cafm.actions.execute({
            url: cafm.url.api("UserSettings/DeleteSearchSetting"),
            values: {
                Key: item.data("key"),
                SubKey: item.data("subkey")
            },
            confirmationPromptMessage: window.SavedSearchList.props.options.deleteConfirmationPromptMessage,
            statusCodeFuncs: {
                204: function (r) {
                    window.SavedSearchList.refresh();
                    if (window.location.hash == hash) {
                        cafm.nav.router.navigateDefault();
                    }
                }
            }
        });
    }

    save(args) {
        
        cafm.filters.openSaveWindow();
    }

    render() {
        this.props.options.OnDataBound = this.dataBound;
        return (
            <div className="saved-searches popup-list-wrapper">
                <h2>{this.props.options.title}</h2>
                <script type="text/x-kendo-template" id={this.props.options.ClientId + "-item-template"}>
                    <li className="k-item" data-key="#:Key#" data-subkey="#:SubKey#">
                        <a className="k-link" href="\#savedSearch/#:SubKey#">#:ValueText#</a>
                        <ButtonGroup>
                            <Button icon="edit" look="bare" data-key="Edit"></Button>
                            <Button icon="delete" look="bare" data-key="Delete"></Button>
                        </ButtonGroup>
                    </li>
                </script>
                <CafmListView options={this.props.options} />
            </div>
        );
    }
}

export class AppList extends React.Component {

    componentDidMount() {
        this.setup();
    }

    setup() {
        $("<span class=\"caret-down\"></span>").appendTo($(".site-logo"));
        cafm.util.callFunctionAsync({
            func: function () {
                $(".site-logo").kendoTooltip({
                    showOn: "click",
                    autoHide: false,
                    content: function (e) {
                        return $(".apps").show();
                    },
                    show: function (args) {
                        cafm.filters.hideFilterPanel();
                        $(".apps").show().closest(".k-animation-container").addClass("header-left-tooltip-container");
                        args.sender.popup.element.addClass("header-widget-tooltip");
                    }
                });
            }, timeout: 100
        });
    }

    render() {
        return (
            <div className="apps popup-list-wrapper">
                <script type="text/x-kendo-template" id={this.props.options.ClientId + "-item-template"}>
                    <li className="k-item">
                        <a className="k-link" href="#:url#">
                            <span className="app-icon #:spriteCssClass#"></span>
                            #:text#
                        </a>
                    </li>
                </script>
                <CafmListView options={this.props.options} />
            </div>
        );
    }
}

export class CompanySelector extends React.Component
{
    componentDidMount() {
        this.setup();
    }

    setup() {
        $("<span class=\"caret-down\"></span>").appendTo($(".companies-menu-item .k-link"));
        cafm.util.callFunctionAsync({
            func: function () {
                $(".companies-menu-item").kendoTooltip({
                    showOn: "click",
                    autoHide: false,
                    content: function (e) {
                        return $(".companies-list").show();
                    },
                    show: function (args) {
                        cafm.filters.hideFilterPanel();
                        $(".companies-list").show().closest(".k-animation-container").addClass("header-right-tooltip-container");
                        args.sender.popup.element.addClass("header-widget-tooltip");
                    }
                });
            }, timeout: 100
        });
    }

    render() {
        this.props.options.OnDataBound = this.dataBound;
        return (
            <div className="companies-list popup-list-wrapper">
                <script type="text/x-kendo-template" id={this.props.options.ClientId + "-item-template"}>
                    <li className="k-item" data-key="#:value#">
                        <a className="k-link">
                            #:data.text#
                        </a>
                    </li>
                </script>
                <CafmListView options={this.props.options} />
            </div>
        );
    }

    dataBound(args) {

        cafm.util.callFunctionAsync({
            func: function () {
                let compDesc = cafm.cache.get('companySelectorComp');
                if (!compDesc) { compDesc = cafm.auth.companyName() };
                $(".companies-menu-item .k-link").attr("title", compDesc);
            }, timeout: 1000
        });

        args.sender.element.find('li.k-item').off('click').on('click', function (item) {
            $(cafm.views.mainViewSelector).showLoader();
            let module = cafm.getCurrentModule();
            let modName = module == 3 ? "CAFMToday" : "ReportsExplorer";
            let currentUrl = cafm.url.getFullPath(modName, false);
            let companyId = $(item.target).parent().data('key');
            cafm.cache.set('companySelectorComp', $(item.target).text());
            cafm.actions.execute({
                url: cafm.url.get('{0}/{1}?id={2}'.format(currentUrl, cafm.res.consts.Url_SwitchCompanySegment, companyId)),
                method: 'GET',
                statusCodeFuncs: {
                    200: function (r) {
                        cafm.router.removeCachedRouteInfo();
                        $(cafm.views.mainViewSelector).hideLoader();
                        cafm.url.set(currentUrl);
                    }
                },
            });
        });
    }
}

export class AuthList extends React.Component {

    componentDidMount() {
        this.setup();
    }

    dataBound(args) {
        args.sender.element.find("> .k-item").each(function (i, e) {

            let itemElement = $(e), item = args.sender.dataItem(itemElement), link = itemElement.find(".k-link");

            if (item.url) {

                link.attr("href", item.url);
            }
            
            if (itemElement.hasClass("logout-item")) {

                link.click(cafm.auth.logout);
            }
        });
    }

    setup() {
        $("<span class=\"caret-down\"></span>").appendTo($(".auth-menu-item .k-link").attr("title", cafm.auth.userDescription()));
        cafm.util.callFunctionAsync({
            func: function () {
                $(".auth-menu-item").kendoTooltip({
                    showOn: "click",
                    autoHide: false,
                    content: function (e) {
                        return $(".auth").show();
                    },
                    show: function (args) {
                        cafm.filters.hideFilterPanel();
                        $(".auth").show().closest(".k-animation-container").addClass("header-right-tooltip-container auth-tooltip-container");
                    }
                });
            }, timeout: 100
        });
    }

    render() {
        this.props.options.OnDataBound = this.dataBound;
        let pName = cafm.auth.userDescription() ? <h2>{cafm.auth.userDescription()}</h2> : null;
        return (
            <div className="auth popup-list-wrapper">
                {pName}
                <script type="text/x-kendo-template" id={this.props.options.ClientId + "-item-template"}>
                    <li className="k-item#: data.cssClass ? (' '+cssClass) : ''#">
                        <a className="k-link">
                            <span className="k-sprite #:spriteCssClass#"></span>
                            #:text#
                        </a>
                    </li>
                </script>
                <CafmListView options={this.props.options} />
            </div>
        );
    }
}

export class CafmListView extends React.Component {

    componentDidMount() {
        this.setup();
    }

    setup() {
        let options = this.props.options;
        let listElement = $("#" + this.clientId);
        let dataSource = cafm.ds.createSearchDataSource({
            element: listElement,
            control: function () { return listElement.getKendoListView(); },
            options: options
        });

        let me = this;
        let templateEl = document.getElementById(this.itemTemplateId);
        let templateHtml = templateEl.innerHTML || templateEl.firstChild.outerHTML;
        listElement.kendoListView({
            dataSource: dataSource,
            template: kendo.template(templateHtml),
            dataBound: args => { me.dataBound(me, args); }
        });
    }

    dataBound(me, args) {

        let options = me.props.options;
        cafm.util.callFunction(options.OnDataBound, args);
    }

    render() {
        let options = this.props.options;
        this.clientId = options.ClientId || cafm.guid.newGuid();
        this.itemTemplateId = "{0}-item-template".format(this.clientId);
        switch ((options.HtmlTagName ? options.HtmlTagName.toLowerCase() : "")) {
            case "ul":
                return (<ul id={this.clientId} className={options.CssClass}></ul>);
            default:
                return (<div id={this.clientId} className={options.CssClass}></div>);
        }
        
    }
}

export class GridColumnChooser extends React.Component {
    constructor(props) {
        super(props);

        this.dataSource = new kendo.data.DataSource({
            data: props.allColumns,
            sort: { field: "title", dir: "asc" },
            schema: {
                model: { id: "field" }
            }
        });

        this.dataBound = function (e) {
            let grid = this;
            let rows = grid.items();

            $(rows).each(function (e) {
                let row = this;
                let dataItem = grid.dataItem(row);

                if (dataItem.visible) {
                    grid.toggleRow(row);
                }

                $(row).children().last().click(function (e) {
                    grid.toggleRow($(e.currentTarget).closest("tr"));
                })
            });
        }

        cafm.filters.applyColumns = function (args) {

            var viewModel = cafm.filters.getViewModel();
            var kgrid = $('.grid-column-chooser .k-grid').getKendoGrid();
            var visibleSelected = cafm.util.transformArray(kgrid.select().toArray(), function (row) {
                return kgrid.dataItem(row);
            });
            var vc = [];

            viewModel.VisibleColumns.forEach(function (field) {

                if (cafm.util.findByFieldValue(visibleSelected, 'field', field)) {

                    vc.push(field);
                }
            });

            visibleSelected.forEach(function (item) {

                if (!cafm.util.findByFieldValue(viewModel.VisibleColumns, null, item.field)) {

                    vc.push(item.field);
                }
            });

            viewModel.set('VisibleColumns', vc);
            cafm.filters.search(cafm.filters.getPanel());
        }
    }

    setupColumnChooser() {
        cafm.util.callFunctionAsync({
            func: function () {
                $(".grid-column-chooser-btn").kendoTooltip({
                    showOn: "click",
                    autoHide: false,
                    content: function (e) {
                        return $(".grid-column-chooser").show();
                    },
                    show: function (args) {

                        args.sender.popup.element.addClass("grid-column-chooser-tooltip");
                    }
                });
            }, timeout: 100
        });

    }

    static toggle(show, wrapperElement) {
        
        let gccBtn = wrapperElement.find(".grid-column-chooser-btn");

        if (gccBtn.length > 0) {
            gccBtn.toggle(show);
        }
    }

    render() {
        this.setupColumnChooser();
        return (
            <div id="grid-column-chooser">
                <button className="k-button k-bare grid-column-chooser-btn">Fields<span className="k-icon k-i-arrow-60-down"></span></button>
                <div className="grid-column-chooser">
                    <Grid dataSource={this.dataSource} dataBound={this.dataBound}>
                        <GridColumn field="visible" selectable="true" width="44px" />
                        <GridColumn field="title" />
                    </Grid>
                    <CafmButtonGroup options={this.props.buttonGroup} />
                </div>
            </div>
        );
    }
}

export class CafmMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
        this.openOnClick = props.options.openOnClick;
        this.closeOnClick = props.options.closeOnClick;

        if (!props.options.customItemRendering) {
            this.dataSource = props.options.items;
        }
    }

    onSelect(e) {
        cafm.util.callFunction(this.props.options.select, e);
    };

    render() {
        if (this.props.options.customItemRendering) {
            var menuItemNodes = this.props.options.items.map(function (item) {
                let css = "k-link" + (item.cssClass ? (" " + item.cssClass) : "");
                if (item.onClick) item.onClick = cafm.util.getReference(item.onClick);
                return (
                    <MenuItem key={item.key || cafm.guid.newGuid()}>
                        <a className={css} href={item.url} title={item.title || item.text} onClick={item.onClick}>{item.spriteCssClass || item.iconUrl ? <MenuItemIcon item={item} /> : item.text}{item.spriteCssClass ? item.text : ''}</a>
                    </MenuItem>
                );
            });
            return (
                <div className={this.props.options.cssClass}>
                    <Menu openOnClick={this.openOnClick} closeOnClick={this.closeOnClick} select={this.onSelect}>
                        {menuItemNodes}
                    </Menu>
                </div>
            );
        }
        else {
            return (
                <div className={this.props.options.cssClass}>
                    <Menu openOnClick={this.openOnClick} closeOnClick={this.closeOnClick} dataSource={this.dataSource} select={this.onSelect}></Menu>
                </div>
            );
        }
    }
}

class MenuItemIcon extends React.Component {
    render() {
        let item = this.props.item;
        if (item.spriteCssClass) {
            let css = "menu-item-icon " + item.spriteCssClass;
            return (
                <span className={css}></span>
            );
        }
        else {
            return (
                <img src={item.iconUrl} alt={item.text} />
            );
        }
    }
}

export class CafmButtonGroup extends React.Component {

    componentDidMount() {
        var element = $(ReactDOM.findDOMNode(this));
        if (this.props.options.enableOverflowMenu) {
            cafm.toolbar.ensureButtonGroupFits = this.setupOverflowMenu(element);
        }

        element.find("[role=presentation]:not(.k-icon,.k-sprite)").addClass("k-sprite");
    }
    setupOverflowMenu(element) {

        let buttonGroup = element,
            otherItemsList = $('<ul>', {
                id: "other-actions-menu",
                "class": "other-actions-menu",
                html: '<li class="other-actions"><span role="presentation" class="other-actions-btn-icon k-sprite"></span>{0}</li>'.format(cafm.res.str.LabelMore)
            }).hide().appendTo(buttonGroup).kendoMenu({
                openOnClick: true,
                animation: false,
                select: function (args) {
                    let item = $(args.item), k = item.data("key"), v = item.data("value");
                    if (!k) return;
                    let btn = buttonGroup.find("> button[data-key={0}]".format(k));
                    if (btn.length) {

                        if (!btn.data("value")) btn.click();
                        else if ((btn = btn.filter("[data-value={0}]".format(v))).length) btn.click();
                    }
                }
            }),
            otherItems = otherItemsList.find(".other-actions"),
            widget = otherItemsList.getKendoMenu();

        otherItems.click(function (e) {
            var t = $(e.target);
            if (!(t.hasClass("other-actions") || t.parent().hasClass("other-actions"))) return;
            widget.open(otherItems);
            e.stopPropagation();
        })
        otherItems.mouseleave(function (e) {
            otherItems.find(".k-item").removeClass("k-state-hover");
            e.stopPropagation();
        })

        let ensureButtonGroupFits = function (buttonGroup) {

            let otherItemsList = buttonGroup.find(".k-menu"),
                otherItems = otherItemsList.find(".other-actions"),
                widget = otherItemsList.getKendoMenu();

            if (!widget) return;

            // move other apps back to top level
            otherItemsList.hide().find(".other-actions .k-item").hide();

            // move other apps back to top level
            buttonGroup.find("[data-moved]").not("[data-secondary]").not("[data-notallowed]").show();

            // close menu if open
            widget.close(otherItems);

            // start by hiding other items
            otherItemsList.hide();

            let isRightFloat = buttonGroup.find("button:first").css("float") === "right";
            if (isRightFloat) {
                otherItemsList.prependTo(buttonGroup);
            }
            else {
                otherItemsList.appendTo(buttonGroup);
            }
            
            let buttonGroupHeight,
                containerHeight,
                setHeightVars = function () {

                    buttonGroupHeight = buttonGroup.outerHeight();
                    containerHeight = buttonGroup.parent().outerHeight();
                },
                move = function (btnItem) {
                    
                    let moveItem;
                    if (btnItem.data("value")) {
                        moveItem = otherItems.find("[data-key={0}][data-value={1}]".format(btnItem.data("key"), btnItem.data("value")));
                    }
                    else {
                        moveItem = otherItems.find("[data-key={0}]".format(btnItem.data("key")));
                    }

                    if (moveItem.length == 1) {

                        //console.log("Show button menu item: " + btnItem.text());
                        moveItem.show();
                    }
                    else if (btnItem.length > 0) {

                        moveItem = $("<li>", {
                            "data-key": btnItem.data('key'),
                            "data-value": btnItem.data('value'),
                            text: btnItem.text()
                        });

                        btnItem.find("span[role=presentation]").clone().prependTo(moveItem);

                        if (otherItems.find('.k-item').length) {

                            //console.log("InsertBefore button menu item: " + btnItem.text());
                            widget.insertBefore(moveItem, otherItems.find('.k-item').first());

                        }
                        else {

                            //console.log("Append button menu item: " + btnItem.text());
                            widget.append(moveItem, otherItems);
                        }
                    }
                    else {

                        return;
                    }

                    btnItem.attr("data-moved", true).hide();
                },
                moveItemToOther = function () {

                    let btnItems = buttonGroup.find("> button:visible").not("[data-primary]").not("[data-secondary]").not("[data-notallowed]");

                    if (!isRightFloat) {
                        btnItems = $(btnItems.get().reverse());
                    }

                    move(btnItems.first());
                };

            let nonSecondary = buttonGroup.find("button").not('[data-secondary]').not('[data-notallowed]');
            let secBtnItems = nonSecondary.length ? buttonGroup.find("button[data-secondary]").not("[data-notallowed]") : $([]),
                hasMovedItem = false;
            if (!isRightFloat) {
                secBtnItems = $(secBtnItems.get().reverse());
            }

            secBtnItems.each(function (i, sel) {
                move($(sel));
                hasMovedItem = true;
            });

            // set height vars
            setHeightVars();

            let i = 0;
            // check if menu fits
            while (buttonGroupHeight > containerHeight) {

                i++;

                // move item into other apps
                moveItemToOther();

                // set height vars
                setHeightVars();

                hasMovedItem = true;

                if (i > 200) {

                    hasMovedItem = false;
                    console.error('Error setting up ButtonGroup overflow menu: too many attempts to fit.');
                    break;
                }
            }

            if (hasMovedItem) {

                // show all apps
                otherItemsList.show();

                // now do 1 last time to ensure all apps fits
                setHeightVars();

                if (buttonGroup.outerHeight() > containerHeight) {

                    moveItemToOther();
                }
            }
        }

        // ensure apps fit
        ensureButtonGroupFits(buttonGroup);

        $(window).resize(function () {

            // ensure apps fit
            ensureButtonGroupFits(buttonGroup);
        });

        return ensureButtonGroupFits;
    }

    render() {

        let select = this.props.options.select;
        this.props.options.items.forEach(function (btn) {
            if (select && !btn.onClick) {
                btn.onClick = function (e) {
                    if (e.currentTarget.disabled === true) return false; 
                    let ref = cafm.util.getReference(select, window);
                    if (isFunc(ref)) {
                        return cafm.util.callFunction(select, { button: btn, event: e });
                    }
                    else if (btn['data-key']) {
                        return cafm.util.callFunction(cafm.util.getReference(btn['data-key'].toLowerCase(), ref), { button: btn, event: e });
                    }
                };
            }
            else if (isStr(btn.onClick)) {
                let onc = btn.onClick;
                btn.onClick = function (e) {
                    if (e.currentTarget.disabled === true) return false; 
                    return cafm.util.callFunction(onc, { button: btn });
                };
            }
            if (isStr(btn.style)) {
                let styleProps = document.createElement('button').style;
                btn.style.split(',').forEach(function (s) {
                    let keyVal = s.split(':');
                    if (keyVal.length == 2) {
                        styleProps[keyVal[0].trim()] = keyVal[1].trim();
                    };
                });
                btn.style = styleProps;
            }
        })
        var buttonNodes = this.props.options.items.map(function (btn) {
            return (
                <Button key={cafm.guid.newGuid()} {...btn}>{btn.text}</Button>
            );
        });
        return (
            <ButtonGroup {...this.props.options}>
                {buttonNodes}
            </ButtonGroup>
        );
    }
}

export class DefaultWorkOrderOrderSearchList extends React.Component {
    componentDidMount() {
        var element = $(ReactDOM.findDOMNode(this));
        element.show();
    }

    render() {
        this.options = this.props.options;
        this.options.HtmlTagName = "div";
        return (
            <div>
                <script type="text/x-kendo-template" id={this.options.ClientId + "-item-template"}>
                    <a className="wo-item k-link" href="#:cafm.url.get('helpdesk\\#editWorkOrder/{0}', ID)#" title="#: cafm.res.str.TemplateView0.format(cafm.res.str.LabelWorkOrder + ' ' + Reference) #">
                        <div className="wo-icon"></div>
                        <div className="wo-body">
                            <h3 className="wo-title">#:Reference#</h3>
                            <span className="list-chevron"></span>
                            <span className="wo-state lcs#:LifeCycleStatus#" title="#:cafm.hd.lcsDescription(LifeCycleStatus)#"></span>
                            <p className="desc" title="#:Description#">#:cafm.util.reduceString(Description, 50, "...")#</p>
                        </div>
                    </a>
                </script>
                <CafmListView options={this.options} />
                <div className="view-all">
                    <a href={this.options.searchPageUrl}>View all</a>
                </div>
            </div>
        );
    }
}

export class DefaultRoomBookingSearchList extends React.Component {
    componentDidMount() {
        var element = $(ReactDOM.findDOMNode(this));
        element.show();
    }

    render() {
        this.options = this.props.options;
        this.options.HtmlTagName = "div";
        return (
            <div>
                <script type="text/x-kendo-template" id={this.options.ClientId + "-item-template"}>
                    <a className="wo-item k-link" href="#:cafm.url.get('roombooking\\#editBooking/{0}', ID)#" title="#: cafm.res.str.TemplateView0.format('{0} [{1}] {2}'.format(cafm.res.str.LabelRoomBooking, Reference, Description)) #">
                        <div className="wo-icon roombooking"></div>
                        <div className="wo-body">
                            <h3 className="wo-title">[#:Reference#] #:Description#</h3>
                            <span className="list-chevron"></span>
                            <p className="desc" title="#:data.Subject#">#:cafm.util.toFormattedDate(ScheduleStart)#, #:RoomDescription#</p>
                        </div>
                    </a>
                </script>
                <CafmListView options={this.options} />
                <div className="view-all">
                    <a href={this.options.searchPageUrl}>View all</a>
                </div>
            </div>
        );
    }
}

export class HoursTicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = props;
    }

    componentWillUnmount() {
        this.stop();
    }

    refresh(updateProps) {
        if (!updateProps) updateProps = {}
        this.setState((prevState, props) => {
            return {
                startTime: updateProps.startTime || prevState.startTime,
                start: updateProps.start || prevState.start
            }
        });
        return this;
    }

    start() {
        let me = this;
        me.stop(); // ensure only 1 interval is running for this instance
        me.interval = setInterval(function () {
            me.refresh();
        }, 1000);
        return this;
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            delete this.interval;
        }
        return this;
    }

    show() {

        $(ReactDOM.findDOMNode(this)).show();
        return this;
    }

    hide() {
        
        $(ReactDOM.findDOMNode(this)).hide();
        return this;
    }

    render() {
        let time = this.state.startTime;
        if (!time)
        {
            return <div className="hours-ticker"></div>
        }

        var d = cafm.web.funcs.getNowUTC({ truncateToMinutes: true });     
        let timespan = cafm.util.getTimeSpanFromMilliseconds(cafm.util.ensureDate(d) - cafm.util.ensureDate(time).getTime(), { excludeYears: true, excludeMonths: true, excludeDays: true});
        //console.log(`timespan:${JSON.stringify(timespan)}; hours:${timespan.hours}; minutes: ${timespan.minutes}`)
        if (timespan) {
            if (this.state.start && !this.interval) {
                let me = this;
                cafm.util.callFunctionAsync({ func: function () { me.start() }, timeout: 10 });
            }
            if (!timespan.hours && !timespan.minutes && this.state.textOnStart) {
                return (
                    <div className="hours-ticker"><span className="hours-pulse"></span>0:00</div>
                );
            }
            else {
                let str = [timespan.hours || 0];
                str.push(kendo.toString(timespan.minutes || 0, "00"));
                if (this.state.showSeconds !== false) {
                    str.push(kendo.toString(timespan.seconds || 0, "00"));
                }
                return (
                    <div className="hours-ticker"><span className="hours-pulse"></span>{str.join(':')}</div>
                );
            }
        }
        else {
            return <div className="hours-ticker"></div>
        }
    }
}